import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import ShopListItemQueue from './shop_list_item_queue';

const shopListItemNameWrapper = {
    "fontFamily": "graphikMedium",
    "height": "100%",
    "marginRight": "1%"
};
const shopListItemName =  {
    "width": "100%",
    "fontSize": "1.3em",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap",
    "overflow": "hidden",
};

export default class ShopListItemBody extends Component {
    render() {
        return (
           <Flexbox height="100%" width="74.5%" flexGrow={1} flexDirection="column">
               <Flexbox style={shopListItemNameWrapper} flexDirection="column-reverse">
                   <div style={shopListItemName}>
                       {this.props.shop.name.slice(0, 32)}
                   </div>
                </Flexbox>
               <ShopListItemQueue shop={this.props.shop}  />
           </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list_item/shop_list_item_body.jsx